import { usePubSub } from "checkout-query-client/hooks/use-pub-sub";
import {
  PubSubMessage,
  PubSubNamespace,
} from "checkout-query-client/publish-subcriber/types";

import {
  sendCustomAction,
  setGlobalContextProperty,
} from "datadog-loader/loader";

let PazePromise: Promise<string> | undefined;

// testing reset function
export const ResetPazePromise = () => {
  PazePromise = undefined;
};

export const initializePaze = async (
  clientId: string,
  merchantName: string
) => {
  if (PazePromise === undefined) {
    PazePromise = window.DIGITAL_WALLET_SDK.initialize({
      client: {
        id: clientId,
        name: merchantName,
      },
    })
      .then((val) => {
        usePubSub()?.publish({
          level: "info",
          namespace: PubSubNamespace.render,
          message: PubSubMessage.PazeLoadSuccess,
        });
        setGlobalContextProperty({
          name: "pazeClientId",
          context: clientId,
        });
        return val;
      })
      .catch((e) => {
        usePubSub()?.publish({
          level: "info",
          namespace: PubSubNamespace.render,
          message: PubSubMessage.PazeLoadFailed,
        });
        sendCustomAction({
          name: "FailedToLoadPaze",
          context: { reason: "Paze Failed to Load" },
        });
        throw e;
      });
  }

  return PazePromise;
};
